module.exports = __webpack_public_path__ + "static/img/QRpic.50527dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/QRpic.png
// module id = liiN
// module chunks = 0